import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import PublicTopbar from './PublicTopbar';

const PublicLayout = () => {
    return (
        <>
            <PublicTopbar />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                }}
            >
                <Outlet />
            </Box>
        </>
    );
};

export default PublicLayout;
